export var Status;
(function (Status) {
    Status[Status["ONE_TIME"] = 0] = "ONE_TIME";
    Status[Status["RECURRING"] = 1] = "RECURRING";
    Status[Status["RECURRING_NEXT"] = 2] = "RECURRING_NEXT";
    Status[Status["RECURRING_LAST_ENDED"] = 3] = "RECURRING_LAST_ENDED";
    Status[Status["RECURRING_LAST_CANCELED"] = 4] = "RECURRING_LAST_CANCELED";
})(Status || (Status = {}));
//# sourceMappingURL=RecurrenceStatus.js.map